import { Alert, Stack } from "@mui/material";
import { ReactNode, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CaseContext } from "../../context/CaseContext";
import { judgmentOf } from "../../shared/judgment";
import { JudgedCaseContext } from "../issues/JudgedRow";

/**
 * A page of what a judgment decided on: read-only while it is in force, as
 * the server refuses changes to it, until Trial is reopened.
 */
export const FrozenByJudgment = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "case.judged" });
  const context = useContext(CaseContext);
  const frozen = judgmentOf(context.getCase()) !== undefined;
  const value = useMemo(
    () => (frozen ? { ...context, readOnly: true } : context),
    [context, frozen],
  );
  if (!frozen) return children;
  return (
    <CaseContext.Provider value={value}>
      <JudgedCaseContext.Provider value={context.getCase()}>
        <Stack spacing={2}>
          <Alert severity="info">{t("frozen")}</Alert>
          {children}
        </Stack>
      </JudgedCaseContext.Provider>
    </CaseContext.Provider>
  );
};
